import React, { useEffect, useState } from 'react';
import { Outlet, useParams, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getBoardsForInvestor } from '../../../../common/services/http/analysisContentService';
import { RootState } from '../../../../redux/store';
import useTranslate from '../../../../common/hooks/useTranslate';

import BoardsTabs from '../../components/boardsTabs/boardsTabs';
import { IBoardDataObject } from '../../../../models/types/IBoardDataObject';

const InvestorBoardsContainer = () => {
  const [loading, setLoading] = useState(true);
  const [boards, setBoards] = useState<IBoardDataObject[]>([]);
  const [noBoards, setNoBoards] = useState(false);
  const params = useParams();
  const navigate = useNavigate();
  const { t } = useTranslate();

  const previouslySelectedBoard = useSelector((state: RootState) => state.board.activeBoard);

  useEffect(() => {
    let isMounted = true;
    setNoBoards(false);
    if (params.investorId) {
      getBoardsForInvestor(params.investorId)
        .then((boards) => {
          if (isMounted) {
            setBoards(boards);
            if (boards.length === 0) setNoBoards(true);
            setLoading(false);
            if (!params.boardId && boards.length > 0) {
              let boardToRedirectTo = boards.find((board) => board.id === previouslySelectedBoard);
              if (!boardToRedirectTo) boardToRedirectTo = boards[0];
              navigate(`/boards/${params.investorId}/${boardToRedirectTo.id}`, { replace: true });
            }
          }
        })
        .catch(() => {
          console.log('error getting boards');
          setLoading(false);
        });
    }

    return () => {
      isMounted = false;
      setBoards([]);
      setLoading(true);
    };
  }, [params.investorId]);

  if (loading) return <div>Loading..</div>;
  if (noBoards) {
    return (
      <div className="no-boards-message-wrapper">
        <p>{t('BOARDS.NO_BOARDS')}</p>
      </div>
    );
  }

  return (
    <>
      <BoardsTabs boards={boards} />
      <Outlet />
    </>
  );
};
export default InvestorBoardsContainer;
